import { actionTypes } from '../../../types';

// Action creator for generating OTP request
export const getOptedCampaignsListByBrand = (payload,callback) => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_REQUEST,
    payload,
    callback
});

// Action creator for successful OTP generation
export const getOptedCampaignsListByBrandSuccess = (payload) => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const getOptedCampaignsListByBrandFailure = (payload) => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const getOptedCampaignsListByBrandReset = () => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_RESET,
});

// Action creator for resetting all OTP generation reducer
export const getOptedCampaignsListByBrandResetAll = () => ({
    type: actionTypes.GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_RESET_ALL,
});
